<div class="overflow-x-auto border-default border-2 rounded-md">
  <proffeo-reports-data-table
    (selectReport)="onSelectReport($event)"
    (selectAll)="onSelectAll()"
    (editReport)="editReport.emit($event)"
    (deleteReport)="deleteReport.emit($event)"
    (taskDetailsOpened)="taskDetailsOpened.emit($event)"
    [rows]="flattenedWorkTimeReports()"
    [columns]="columns()"
    [selectedIds]="selectedTimeReportIds()"
    [allSelectableIds]="allSelectableIds()"
    [selectableReportIds]="allSelectableIds()"
    [selectionDisabled]="selectionDisabled()"
    [sortable]="!isMobile()"
    [showSelectAll]="true"
    durationPipe="intlDuration"
  />
</div>
